import {
  WEBVIEW_DISABLED_INPUT,
  WEBVIEW_SET_FOCUS_INPUT,
  WEBVIEW_SKYP_USER_INPUT,
} from "actions/const";
import {
  STATE_WEBVIEW_DEFAULT,
  STATE_WEBVIEW_IS_INPUT_DISABLED,
  STATE_WEBVIEW_IS_FOCUS,
  STATE_WEBVIEW_IS_SKIP_USER_INPUT,
} from "./default";
import { createReducer } from "../base";

export default createReducer(STATE_WEBVIEW_DEFAULT, {
  [WEBVIEW_DISABLED_INPUT]: (state, { payload }) =>
    state.set(STATE_WEBVIEW_IS_INPUT_DISABLED, payload),
  [WEBVIEW_SET_FOCUS_INPUT]: (state, { payload }) =>
    state.set(STATE_WEBVIEW_IS_FOCUS, payload),
  [WEBVIEW_SKYP_USER_INPUT]: (state, { payload }) =>
    state.set(STATE_WEBVIEW_IS_SKIP_USER_INPUT, payload),
});

export * from "./selectors";
export * from "./default";
